/**
 * Calculate category counts from dishes array
 * @param {Array} categories - Array of category objects
 * @param {Array} dishes - Array of dish objects
 * @returns {Array} Categories with updated counts
 */
export const calculateCategoryCounts = (categories, dishes) => {
  return categories?.map(category => ({
    ...category,
    count: category?.id === 'all' 
      ? dishes?.length 
      : dishes?.filter(dish => dish?.category === category?.id)?.length
  }));
};

/**
 * Group dishes by category
 * @param {Array} dishes - Array of dish objects
 * @param {Array} categories - Array of category objects
 * @param {string} activeCategory - Currently selected category
 * @returns {Object} Dishes grouped by category
 */
export const groupDishesByCategory = (dishes, categories, activeCategory) => {
  const grouped = {};
  
  if (activeCategory === 'all') {
    categories?.forEach(category => {
      if (category?.id !== 'all') {
        grouped[category.id] = dishes?.filter(dish => dish?.category === category?.id);
      }
    });
  } else {
    grouped[activeCategory] = dishes;
  }

  return grouped;
};

/**
 * Format price with currency symbol
 * @param {number} price - Price value
 * @param {string} currency - Currency code (default: 'CAD')
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, currency = 'CAD') => {
  return new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: currency
  })?.format(price);
};

/**
 * Get spice level label
 * @param {number} level - Spice level (0-5)
 * @returns {string} Spice level label
 */
export const getSpiceLevelLabel = (level) => {
  const labels = {
    0: 'Doux',
    1: 'Légèrement épicé',
    2: 'Moyennement épicé',
    3: 'Épicé',
    4: 'Très épicé',
    5: 'Extrêmement épicé'
  };
  return labels?.[level] || 'Non spécifié';
};